import React from 'react';
import { connect } from 'react-redux';
import { userInfoFormUpdate, userInfoFormError, userInfoUpdate } from '../../actions/userInfoForm';
import { setAccountPanel } from '../../actions/panels';
import LoadingSpinner from '../common/LoadingSpinner';
import { ModalCloseButton } from '../common/ModalCloseButton';
import account from '../../assets/images/account.svg';

class ProfileInformation extends React.Component {

    constructor(props) {
        super(props);

        this.onInfoUpdateButtonPress = this.onInfoUpdateButtonPress.bind(this);

        this.state = {
            errorNotification: false,
            successNotification: false ,
            notification: ""
        }
    }

    componentDidMount() {
        
        // nothing here yet, delete if not required
        this.props.dispatch(userInfoFormUpdate({ prop: 'first_name', value: this.props.user.first_name }));
        this.props.dispatch(userInfoFormUpdate({ prop: 'last_name', value: this.props.user.last_name }));
        this.props.dispatch(userInfoFormUpdate({ prop: 'phone', value: this.props.user.phone }));
    }

    onInfoUpdateButtonPress() {

        const { first_name, last_name, phone, password, password_confirm, token, dispatch } = this.props;

		if (first_name.match(/^\s*$/)) {

            dispatch(userInfoFormError("Please enter your first name."));
		}
		else if (last_name.match(/^\s*$/)) {
            dispatch(userInfoFormError("Please enter your last name."));
		}
		else if (phone.match(/^\s*$/)) {
            dispatch(userInfoFormError("Please enter your phone number."));
		}
		else if (!phone.match(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/)) {
            dispatch(userInfoFormError("Invalid phone number supplied. Must be 10 digits eg. 9876543210"));
		}
		else if ((password.match(/^\s*$/) && !password_confirm.match(/^\s*$/)) || (password_confirm.match(/^\s*$/) && !password.match(/^\s*$/)) || password != password_confirm) {
            dispatch(userInfoFormError("Invalid password info supplied."));
		}
		else {
            const params = {
                first_name,
                last_name,
                phone,
                password,
                password_confirm,
                token
            };
            dispatch(userInfoUpdate(params));
        }
    }
   
    render() {

        if (this.props.loading) {
            return (
                <LoadingSpinner />
            )
        }

        return (
            <div>
                <div className="close-button">   
                    <ModalCloseButton 
                        clickAction={() => this.props.dispatch(setAccountPanel('info'))} 
                    />
                  </div>
                  <div className="item-info-wrapper">
                       <h2 className="heading in-item">Update Account Settings</h2>
                       <div  className="fine-print-small">You can update your user information and password here. if you don't want to update the password, just leave it blank!</div>
                        
                       <div>
                        {(this.props.error != "") && <p className="error-text">{this.props.error}</p>}
                            {(this.props.success != "") && <p className="success-text">{this.props.success}</p>}
                        </div>
                        <div className="h3-header no-top-pad">User Info:</div>
                        <div className="w-form">
                            <div className="input-email-window">
                                <p className="field-label">First Name</p>
                                <input 
                                    type="text"
                                    className="text-field-input"
                                    placeholder="required"
                                    value={this.props.first_name}
                                    onChange={(e) => this.props.dispatch(userInfoFormUpdate({ prop: 'first_name', value: e.target.value }))}
                                />
                            </div>

                            <div className="input-email-window">
                                <p className="field-label">Last Name</p>
                                <input 
                                    type="text"
                                    className="text-field-input"
                                    placeholder="required"
                                    value={this.props.last_name}
                                    onChange={(e) => this.props.dispatch(userInfoFormUpdate({ prop: 'last_name', value: e.target.value }))}
                                />
                            </div>

                            <div className="input-email-window">
                                <p className="field-label">Phone</p>
                                <input 
                                    type="text"
                                    className="text-field-input"
                                    placeholder="required"
                                    isPhone={true}
                                    value={this.props.phone}
                                    onChange={(e) => this.props.dispatch(userInfoFormUpdate({ prop: 'phone', value: e.target.value }))}
                                />
                            </div>
                        </div>
                        <h3 className="h3-header less-top-pad">Update Password:</h3>
                        <div className="form-block-with-bottom-pad w-form">
                            <div className="input-email-window">
                                <p className="field-label">New Password</p>
                                <input 
                                    type="password"
                                    className="text-field-input"
                                    placeholder="required"
                                    value={this.props.password}
                                    onChange={(e) => this.props.dispatch(userInfoFormUpdate({ prop: 'password', value: e.target.value }))}
                                />
                            </div>
                            <div className="input-email-window">
                                <p className="field-label">New Password</p>
                                <input 
                                    type="password"
                                    className="text-field-input"
                                    placeholder="required"
                                    value={this.props.password_confirm}
                                    onChange={(e) => this.props.dispatch(userInfoFormUpdate({ prop: 'password_confirm', value: e.target.value }))}
                                />
                            </div>
                            <div className="account-button in-receipt usual-orders update-modal-margin"
                                 onClick={this.onInfoUpdateButtonPress}
                            >
                                <img src={account} loading="lazy" className="button-icon white " />
                                <div>Update Profile Info</div>
                            </div>
                        </div>  
                  </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        user: state.auth.user,
        token: state.auth.token,
        first_name: state.userInfoForm.first_name,
        last_name: state.userInfoForm.last_name,
        phone: state.userInfoForm.phone,
        password: state.userInfoForm.password,
        password_confirm: state.userInfoForm.password_confirm,
        loading: state.userInfoForm.loading,
        error: state.userInfoForm.error,
        success: state.userInfoForm.success
    };
};

export default connect(mapStateToProps)(ProfileInformation);